const Login = () => import('~pages/Auth/Login.vue')
const RegisterConfirmation = () => import('~pages/Auth/RegisterConfirmation.vue')
const ForgotPassword = () => import('~pages/Auth/ForgotPassword.vue')
const Invites = () => import('~pages/Auth/Invites.vue')

export default [
  {
    name: 'login',
    path: '/login',
    component: Login,
    meta: {
      bypassToken: true
    }
  },
  {
    name: 'confirmation',
    path: '/register/confirmation',
    component: RegisterConfirmation,
    meta: {
      bypassToken: true
    }
  },
  {
    name: 'forgot-password',
    path: '/forgot-password',
    component: ForgotPassword,
    meta: {
      bypassToken: true
    }
  },
  {
    name: 'invites',
    path: '/invites',
    component: Invites,
    meta: {
      bypassToken: true
    }
  }
]
